// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3Cx0K{max-width:1440px;max-width:90rem;margin:0 auto}._3Cx0K,.Vuoox{position:relative}.Vuoox{display:block;padding-bottom:52.47%;border-radius:.5rem;overflow:hidden;-webkit-box-shadow:0 .5rem 1.5rem 0 rgba(159,160,160,.4);box-shadow:0 .5rem 1.5rem 0 rgba(159,160,160,.4)}.xnTdo{width:100%;height:286px;height:17.875rem;position:absolute}@media(max-width:767px){.xnTdo{height:7.87rem}}._1G2SS{position:absolute;-o-object-fit:cover;object-fit:cover;width:100%;height:100%}._1WZq1 .swiper-wrapper{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}", ""]);
// Exports
exports.locals = {
	"root": "_3Cx0K",
	"slide": "Vuoox",
	"loading": "xnTdo",
	"img": "_1G2SS",
	"swiperCenter": "_1WZq1"
};
module.exports = exports;
